export default __webpack_public_path__ + "static/media/dustbin-icon.8ebef1c0.svg";